import { render, staticRenderFns } from "./EModalDuplicarAulaInfantil.vue?vue&type=template&id=e6c13d30&scoped=true"
import script from "./EModalDuplicarAulaInfantil.vue?vue&type=script&lang=js"
export * from "./EModalDuplicarAulaInfantil.vue?vue&type=script&lang=js"
import style0 from "./EModalDuplicarAulaInfantil.vue?vue&type=style&index=0&id=e6c13d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c13d30",
  null
  
)

export default component.exports